/* ==========================================================================
   sp-catalog.js - the collection page filter, built in the theme, no app.

   Lorenzo, 21 October 2026: "can we build a filter using our own theme without
   using any app", then "Yes build it. make it better and faster and using the
   theme style and design as the new-ring product page theme".

   HOW IT IS FAST
   The first 24 rings are drawn by Liquid on the server, so they are on the
   screen before this file has even been read, they are real links a search
   engine can follow, and they are there when JavaScript is switched off.
   Then the WHOLE collection is fetched once in the background - every page of
   templates/collection.sp-catalog-data.liquid at the same time, not one after
   another, because the section already told us how many rings there are - and
   kept in sessionStorage. After that every filter, every count and every sort
   happens here in the browser with NO request at all.

   MEASURED on /collections/his, 336 rings: 2 requests, 45.8 KB over the wire,
   0.50 to 0.66 s for the lot over three runs, all in the background. 250 rings
   is as many as Liquid will hand over at once (measured - see the data
   template), so two requests cover the whole collection. Globo's filter and
   search on the live theme was 21 requests and 207 KB before a shopper could
   touch anything.

   WHAT IS NOT HERE
   No third-party anything. One file, loaded with defer. The styles live in
   sections/sp-catalog.liquid.

   ---------------------------------------------------------------------------
   21 October 2026, Lorenzo, on his phone:
     "Can we have the options on the mobile collapsed by default / Use the full
      width of the device screen / Show the filter selections on the top with
      option to remove same as we see them once the filter pan is closed. /
      Change the price to slider for both the mobile and desktop / Add a clear
      all option / The total number of rings showing on the top needs better
      positon colour and size"

   So, in this file: the phone panel's groups started shut (REVERSED on 22
   October - the last paragraph of this comment), a shut group with ticks in it
   says how many, the chips row is drawn twice - on the page and inside the
   panel - and the price bands are gone, replaced by a two-handle slider built
   from two plain range inputs with no library. The panel's full width and full
   height, the count's colour, size and place, and the slider's looks are all in
   sections/sp-catalog.liquid.

   ---------------------------------------------------------------------------
   22 October 2026, Lorenzo: "add search option for within each filter. Show
   onl if there are more than 10 values" - and then, later the same day, that
   it should come back out again. See the last paragraph of this comment.

   ---------------------------------------------------------------------------
   22 October 2026, Lorenzo: "Remove Thickness too", and "chnge the width to a
   slider".

   So Thickness is not a filter any more - its line is gone from GROUPS - and
   Width is a two-handle slider instead of a list of ticks, in the same place
   in the column as before, after Metal and before Profile.

   The second slider is NOT a copy of the first. A slider is now DESCRIBED -
   its key, what it is called, how to read a ring's number or numbers, the
   notch it moves in, how an amount is written - and ONE set of functions
   draws and works both of them. See GROUPS and SLIDERS below.

   ---------------------------------------------------------------------------
   22 October 2026, Lorenzo: "For now can we change the theme to same option as
   the current live theme filter with the swatches of the Material and profile.
   Remove the tickens and make width a slider" ("tickens" is Thickness).

   So this filter now has the same four groups the live theme's app shows, less
   Thickness, in this order: PRICE (slider), MATERIAL (picture swatches),
   PROFILE (picture swatches), WIDTH (slider). Metal, Inlay, Inner sleeve,
   Finish, Design and the Offer row are gone with it. An old link carrying any
   of their spf_ parameters is simply ignored, exactly as spf_karat is.

   Material and Profile now come from THE TAGS - Material_<name> and
   Profile_<name> - which is where the live app reads them, and no longer from
   the materials line under the ring's name (Profile no longer reads the ring's
   own Profile option either, which is what made its counts one higher than
   live's on three values). MEASURED off the data feed, His, 336 rings: all 14
   Material counts and all 4 Profile counts are the live app's own counts to
   the ring. The line under each ring's name on its card is untouched.

   The materials-line tidy-up that Material used to need - materials(),
   MAT_SAME, MAT_HIDE, MAT_JOINS, MAT_UNDER - is therefore gone from this file.
   Lorenzo said "for now", so it is kept in git, not here: commit a078aa3 (or
   12a2eca) holds the whole of it in this same file.

   The swatch pictures are the live app's own, COPIED INTO THE THEME as
   assets/sp-swatch-<group>-<name>.<jpg|png> - so nothing on the page asks
   Globo's image server for anything and the filter still has its pictures the
   day Globo is removed. The section hands them over in data-sp-config, by
   value name in lower case; see swatchOf below.

   ---------------------------------------------------------------------------
   22 October 2026, Lorenzo, later the same day: "Remove the search within the
   options and show all by default and expanded by default. For mobile show
   Apply button on top ring instead of X. one the deskotp need 4 material each
   row same as mobile" ("top ring" is the top right).

   THREE THINGS CAME OUT OF THIS FILE - taken out, not hidden.

   1. THE SEARCH BOX INSIDE A GROUP IS GONE, with everything that only served
      it: SEARCH_AT, findNorm, canFind, findHtml, groupInner, typeFind, the
      words kept per group, the two keys they answered and the putting back of
      the cursor after a redraw. It lived for a few hours; commit 12a2eca holds
      the whole of it in this same file if it is ever wanted again.

   2. THE "SHOW ALL N" CUT-OFF IS GONE. Every value of every group is drawn,
      every time - SHOW_AT_FIRST, the showAll memory and the button with them.
      It was eight values at first; commit 3d16c0a holds it.

   3. EVERY GROUP STARTS OPEN, in the phone's panel as well as in the
      computer's sidebar. This REVERSES his 21 October ask, "Can we have the
      options on the mobile collapsed by default": he has looked at it and
      asked for the other thing, so groupShell below no longer cares which of
      the two lists it is drawing. A group can still be shut by tapping its
      header, and a shut group with ticks in it still says "Material (2)" in
      the panel.

   The Apply button at the top right of the phone's panel is in
   sections/sp-catalog.liquid: it closes the panel through the same
   data-sp-panel-apply this file has always answered, so there is nothing new
   here for it. The four-across Material and Profile tiles in the computer's
   sidebar are that file's CSS only.

   --------------------------------------------------------------------------
   23 October 2026, Lorenzo: "There is a dealy in loading he filter when the
   page loas. How can we make it load faster along with the rest of the page".

   THE FILTER IS NOW DRAWN BY LIQUID, WITH THE PAGE, and this file takes it
   over instead of drawing it again. MEASURED before: the rings were painted
   with the HTML but the filter column was four grey boxes until about 1.6 s,
   because this script is deferred (so it did not run until 820 ms) and only
   then asked for the feed it needed to work the values out.

   FOUR THINGS CHANGED HERE, and every one of them is to make this file and
   sections/sp-catalog.liquid agree about what the filter looks like:

   1. MATERIAL AND PROFILE ARE IN ALPHABETICAL ORDER, not commonest first.
      Liquid knows the tag names but cannot count rings without walking all
      336, so the alphabet is the only order both can draw - and it is the live
      app's own order anyway ("sort":"asc"). See alpha in GROUPS.
   2. THE FEED IS FETCHED AS THE SAME REQUEST THE SECTION PRELOADS, so the
      browser hands over the answer it has already downloaded instead of
      downloading it twice. See load().
   3. THE MONEY SYMBOL COMES FROM THE SECTION, because the section needs it to
      write the price slider's two amounts and the two must not disagree.
   4. THE FIRST DRAW KEEPS THE SERVER'S OWN NODES: paintInto, sameValues and
      fillCounts below change the counts, the hidden state and the ticks and
      leave every picture and every row where it is. Nothing in the filter
      column moves when the data lands.
   ========================================================================== */

(function () {
  'use strict';

  var VER = '2';                            // bump to throw away every cached copy

  /* ------------------------------------------------------------------------
     THE FILTER GROUPS.

     Every group is worked out from the ring's own data - there is no list of
     values written down anywhere. What IS written down is where to look and
     what to call it, because the shop's tags carry a lot that is not a filter
     ("collection_his", "SALE30", "Size", "BestSeller") and a few that are
     plainly a mistake ("The_...", "top_...", "elite_...").

     tags:  tag prefixes, matched without caring about capitals, so "width_7mm"
            and "Width_7mm" are the same group, and so are "Inner Sleeve_",
            "InnerSleeve_" and "inner Sleeve_".
     opts:  the ring's own option names (Karat, Width, ...), also without caring
            about capitals.
     kind:  'mm' turns "8mm", "8 mm" and "8.00 mm" into one value, "8 mm", and
            sorts the group by the number. 'karat' turns "14k" into "14K".
     swatch: this group's values are drawn as picture tiles instead of rows of
            ticks - a round picture, the name and the count. The pictures are
            theme assets, handed over by the section; a value the theme has no
            picture for gets a cream circle with its first letter, so a new tag
            can never leave a hole. MEASURED on His and on Custom Wedding
            Rings: every Material and Profile value has a picture.
     slider: this group is a two-handle slider instead of a list of ticks. The
            rest of its description is in SLIDERS below, under the same key.
            THE ORDER OF THIS LIST IS THE ORDER ON THE SCREEN, sliders and
            swatch and tick groups together. It is the live app's own order
            now: Price, Material, Profile, Width.

     TO ADD A GROUP: add a line here. Nothing else. A group with fewer than two
     different values is dropped on its own, so a group that carries no
     information never appears - MEASURED: "Fit" has one value on every ring in
     His, and product type is "Rings" on all but one, so neither is a filter.

     FOUR GROUPS, AND THEY ARE THE LIVE THEME'S OWN FOUR LESS THICKNESS.
     Lorenzo, 22 October: "For now can we change the theme to same option as
     the current live theme filter with the swatches of the Material and
     profile. Remove the tickens and make width a slider". The live app shows
     Price, Material, Profile, Width, Thickness - so this is that list in that
     order with Thickness taken off the end, and Metal, Inlay, Inner sleeve,
     Finish, Design and Offer are gone as well.

     Each of them comes back as one line, which is the only reason they are
     written out here:
       { key: 'metal',     label: 'Metal',        tags: ['core'], opts: ['metal'] }
       { key: 'inlay',     label: 'Inlay',        tags: ['inlay'] }
       { key: 'sleeve',    label: 'Inner sleeve', tags: ['inner sleeve', 'innersleeve'], opts: ['sleeve'] }
       { key: 'finish',    label: 'Finish',       tags: ['finish'] }
       { key: 'design',    label: 'Design',       tags: ['design'] }
       { key: 'thickness', label: 'Thickness',    tags: ['thickness'] }
       { key: 'karat',     label: 'Karat',        opts: ['karat'], kind: 'karat' }
     Karat, Style and Diamond went on 22 October ("Remove the Karat, Diamond
     and style filters") and Thickness the same day ("Remove Thickness too").
     The Offer row (On sale) and the Availability row were never in this list -
     they were drawn beside it, and that code is gone from this file too.

     AN OLD LINK IS IGNORED, NOT HALF UNDERSTOOD. spf_metal=, spf_inlay=,
     spf_thickness=, spf_sale= and the rest are read by nothing now: the rings
     come back without that filter and the parameter sits harmlessly in the
     address, exactly as spf_karat has since 22 October.

     MATERIAL AND PROFILE ARE TAGS, like the live app reads them. Material was
     the materials line under the ring's name until today and Profile also read
     the ring's own Profile option; both now read ONLY the Material_ and
     Profile_ tags. MEASURED off the data feed on His: that gives the live
     app's own counts to the ring on all 18 values, and the option added 1 to
     Bevel, Domed and Flat from the single ring that carries one.
     ------------------------------------------------------------------------ */
  /* alpha: this group's values are drawn in ALPHABETICAL order rather than
            commonest first. Lorenzo, 23 October, asked for the filter to be
            drawn with the page, and Liquid can draw a list in alphabetical
            order (it knows the tag names) but cannot count rings without
            walking all 336. So the order that both can agree on is the
            alphabet - and it is the live app's own order besides: Globo's
            config says "sort":"asc" and its column reads Aluminum, Black
            Titanium, Carbon Fiber ... and Bevel, Domed, Flat, Step. Width
            still sorts by the number, which it always did.

     all:   ticking several values of this group keeps only the rings that
            have EVERY ONE of them; every other group keeps a ring that has
            any one. Lorenzo, 31 October: "The material should be and filter
            where all the materails filtered should give us ring that has all
            the materaisl filtered." A ring is made of several materials -
            MEASURED on His: 188 of the 336 carry two or more - so Carbon Fiber
            and Wood can mean one ring with both. Profile and Width were not
            asked for and stay as they were; a ring has one profile in any
            case. keep() and facets() are the two places that read this. */
  var GROUPS = [
    { key: 'price',     label: 'Price',         slider: true },
    { key: 'material',  label: 'Material',      tags: ['material'], swatch: true, alpha: true, all: true },
    { key: 'profile',   label: 'Profile',       tags: ['profile'],  swatch: true, alpha: true },
    { key: 'width',     label: 'Width',         tags: ['width'], opts: ['width'], kind: 'mm' }
  ];

  /* ------------------------------------------------------------------------
     THE PRICE SLIDER - and it is the only one now.

     Width was a slider for a few hours on 22 October ("chnge the width to a
     slider") and Lorenzo has asked for the list back: "Another update for the
     filter. Make the width the list as before not slider". So the width line
     in GROUPS above has lost its slider: true and nothing else - it reads the
     same width_ tags and the same Width option it always did, tidied by the
     same 'mm' kind, so "8mm", "8 mm" and "8.00 mm" are still one value. The
     rows sort by the number, not by how many rings each has, because
     sortValues treats kind 'mm' as a number.

     A LINK IN THE SLIDER'S FORM IS DROPPED WHOLE. spf_width=6-8 reads as one
     tick value called "6-8", which is not a width this shop has, and index()
     already throws away any value a group does not carry. So an old slider
     link comes back as Width with nothing ticked rather than as an empty grid.

     The slider machinery below is untouched and still serves Price. It is
     written as a table on purpose: another slider is a line in GROUPS with
     slider: true and an entry here, and nothing else.

     vals(p):   every number this ring has for this slider - Price has exactly
                one, the "from" price its card shows.
     step(c):   the notch the handles move in. Price's is a section setting,
                $25 by default (README section 23 says why $25).
     amount(c, n): how one end is written for a shopper - "$200".
     ends:      the two handles' own names, for a screen reader.
     needTwo:   no slider at all unless the collection has two different
                values. Price is deliberately NOT given it: it has been drawn
                whatever the prices are since the day it was built, and this
                change is not the place to start altering that.
     ------------------------------------------------------------------------ */
  var SLIDERS = {
    price: {
      vals: function (p) { return [p._pr]; },
      step: function (c) { return c.priceStep(); },
      amount: function (c, n) { return c.money(n); },
      ends: ['Lowest price', 'Highest price']
    }
  };
  /* Each description is folded onto its own line in GROUPS, so there is one
     list and one order: what is drawn, and in what order, is GROUPS from top
     to bottom whichever kind each line is. TICKS and SLIDE are just that one
     list split in two, for the handful of places that only ever mean one kind
     - reading and writing the address bar, and emptying everything. */
  GROUPS.forEach(function (g) {
    if (!g.slider) return;
    var d = SLIDERS[g.key];
    Object.keys(d).forEach(function (k) { g[k] = d[k]; });
  });
  var TICKS = GROUPS.filter(function (g) { return !g.slider; });
  var SLIDE = GROUPS.filter(function (g) { return g.slider; });

  /* EVERY SORT THE CONTROL OFFERS. Lorenzo, 22 October: "We dont have all the
     options for sorting as the app" - so the list is now the ten the Globo app
     shows on the live theme, read off its own dropdown, in its own order and
     with its own labels. The <option> tags are in sections/sp-catalog.liquid,
     which is where the order and the words live; this list is only what readUrl
     will accept out of the address, so a stale or hand-typed sort_by falls back
     to the page default instead of leaving the Sort box blank.

     There used to be a SORTS array here that was declared and never read once -
     the select has always been drawn by the section. This replaces it.

     manual and relevance both mean THE ORDER THE FEED ARRIVED IN: the
     collection's own order on a collection, Shopify's relevance order on a
     search. They are two names for one behaviour because the two pages say it
     differently to the shopper ("Featured" and "Relevance").

     stock-descending and sale-descending are OURS, worked out here from the
     feed. Shopify does not know either word, so in the degraded path below -
     where the data never arrived and the sort is handed back to Shopify - those
     two do nothing. That is the right way round: without data we cannot sort by
     them honestly either. */
  var SORT_OK = [
    'manual', 'relevance', 'stock-descending', 'best-selling',
    'title-ascending', 'title-descending', 'price-ascending', 'price-descending',
    'created-descending', 'created-ascending', 'sale-descending'
  ];

  /* NO CUT-OFF, NO SEARCH BOX. Lorenzo, 22 October: "Remove the search within
     the options and show all by default". So there is no SHOW_AT_FIRST and no
     SEARCH_AT in this file any more: every value of every group is drawn every
     time, and nothing narrows a list but the shopper's own ticks. */

  /* ---------------------------- small helpers ---------------------------- */

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function uniqPush(arr, v) { if (v && arr.indexOf(v) < 0) arr.push(v); }

  /* DIGITS, AND AT MOST ONE DOT: "200", "4", "12.5", and nothing else. This is
     what keeps a half-understood slider link out of the address bar - see
     readUrl. parseFloat on its own would read "7 mm" as 7 and quietly make up
     a range nobody asked for. Written without a backslash, like every other
     pattern in this file; [.] is a dot that needs no escape. */
  function plainNum(s) {
    return /^[0-9]+([.][0-9]+)?$/.test(String(s == null ? '' : s).trim());
  }

  function canon(g, v) {
    v = String(v == null ? '' : v).trim();
    if (!v) return '';
    // "8mm", "8 mm" and "8.00 mm" are all the same width to a shopper, so they
    // become one value, "8 mm", and the group sorts by the number.
    if (g.kind === 'mm') {
      var m = v.match(/[0-9][0-9.]*/);
      if (!m) return '';
      return (Math.round(parseFloat(m[0]) * 100) / 100) + ' mm';
    }
    if (g.kind === 'karat') {
      var k = v.match(/^([0-9]+)[ ]*[kK]$/);
      return k ? k[1] + 'K' : v;
    }
    return v;
  }

  // Thousands separator without a regex, so this whole file stays free of
  // backslashes - the Admin API upload path mangles some escapes.
  function group3(n) {
    var s = String(n), out = '', i, c = 0;
    for (i = s.length - 1; i >= 0; i--) {
      out = s.charAt(i) + out;
      c++;
      if (c % 3 === 0 && i > 0) out = ',' + out;
    }
    return out;
  }

  function sortValues(g, vals) {
    var counts = g._counts || {};
    return vals.slice().sort(function (a, b) {
      if (g.kind === 'mm' || g.kind === 'karat') return parseFloat(a) - parseFloat(b);
      // Alphabetical, so the list the section draws with the page and the list
      // this file draws when the data lands are the same list in the same
      // order. See the note on alpha in GROUPS above.
      if (g.alpha) return a.localeCompare(b);
      var d = (counts[b] || 0) - (counts[a] || 0);
      return d !== 0 ? d : a.localeCompare(b);
    });
  }

  /* ============================== one section ============================= */

  function Catalog(root) {
    var self = this;
    this.root = root;
    this.cfg = JSON.parse($('[data-sp-config]', root).textContent);

    this.el = {
      count:   $('[data-sp-count]', root),
      side:    $('[data-sp-side]', root),
      sideClear: $('[data-sp-side-clear]', root),
      chips:   $('[data-sp-chips]', root),
      panelChips: $('[data-sp-panel-chips]', root),
      footClear: $('[data-sp-foot-clear]', root),
      grid:    $('[data-sp-grid]', root),
      loading: $('[data-sp-loading]', root),
      empty:   $('[data-sp-empty]', root),
      more:    $('[data-sp-more]', root),
      sort:    $('[data-sp-sort]', root),
      sortForm: $('[data-sp-sortform]', root),
      sticky:  $('[data-sp-sticky]', root),
      panel:   $('[data-sp-panel]', root),
      panelBody: $('[data-sp-panel-body]', root),
      // The foot's button, the one that says "Show N rings". It is asked for by
      // a hook of its own because the panel now has TWO buttons that close it -
      // Apply at the top right and this one - and both answer the same
      // data-sp-panel-apply.
      panelBtn:  $('[data-sp-panel-count]', root),
      openFilter: $('[data-sp-open-filter]', root),
      fcount:  $('[data-sp-fcount]', root),
      scrim:   $('[data-sp-scrim]', root)
    };

    this.items = null;      // every ring in the collection, in the collection's order
    this.best = null;       // handle -> position, under Shopify's best-selling order
    this.groups = [];       // the groups that carry information, in GROUPS order
                            // - each slider's own two ends and its notch are
                            // worked out in index(), on the group itself
    this.state = this.readUrl();
    this.degraded = false;
    this.busy = false;

    this.bindStatic();
    this.begin().then(function () { self.ready(); }, function (err) { self.breakDown(err); });
  }

  /* WHERE A PAGE'S RINGS COME FROM - 25 October 2026.

     A COLLECTION is unchanged: its own feed, its own order, no filtering, and
     not one line of this runs.

     A SEARCH WITH WORDS TO FILTER ON now starts from THE WHOLE CATALOGUE, because
     Shopify's own search cannot hand back a ring whose word lives only in
     custom.product_materials or inside a joined tag - measured, six rings on
     this shop. The catalogue is filtered by the rule; if anything matches, that
     IS the page: the count, the filter groups, the grid and the tab's own title.

     IF NOTHING IN THE CATALOGUE MATCHES, Shopify's own search feed is fetched and
     used exactly as it was before - unfiltered, in Shopify's order. That is what
     keeps a misspelling working: "meteroite" matches no ring in the catalogue, so
     the shopper gets Shopify's guess rather than an empty page.

     A SEARCH WITH NO WORDS LEFT - somebody typed "rings" - does not come here at
     all. It keeps Shopify's own list, as it did in round four, because the
     shopper has not actually narrowed anything and Shopify's relevance for a bare
     word is better than the catalogue in catalogue order.

     THE HIDDEN PRODUCTS GO FIRST. The catalogue holds things Shopify keeps out of
     search - "Custom", "Priority" and the ring sizer all carry seo.hidden - and
     the feed marks them "sx". They are dropped here so that this page is never
     MORE visible than Shopify's own search, only less padded. */
  Catalog.prototype.begin = function () {
    var self = this;
    var words = this.searchWords();
    if (!this.cfg.is_search || !words.length || !this.cfg.cat_url || !matcher()) {
      return this.load().then(function () {
        if (self.cfg.is_search && words.length) {
          var kept = self.onlyMatching(self.items);
          if (kept.length) { self.items = kept; retitle(kept.length); }
        }
      });
    }

    return this.loadCatalogue().then(function (all) {
      var open = all.filter(function (p) { return !p.sx; });
      var kept = self.onlyMatching(open);
      if (!kept.length) {
        /* Nothing in the whole shop carries the words: Shopify's own answer,
           exactly as before. */
        return self.load();
      }
      self.fromCatalogue = true;
      return self.loadBestFor(self.cfg.cat_handle, self.cfg.cat_count, self.cfg.cat_order_url)
        .then(function () {}, function () { /* no order to be had: groups still hold */ })
        .then(function () {
          self.items = self.byRelevance(kept);
          retitle(self.items.length);
        });
    });
  };

  /* The catalogue feed, cached under the key /collections/all itself would use.
     WHAT IS CACHED IS NOT FILTERED, so a change to the rule takes effect on the
     next page view rather than needing anybody to clear a cache. */
  Catalog.prototype.loadCatalogue = function () {
    var key = this.catKey(), cfg = this.cfg;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) {
        var parsed = JSON.parse(hit);
        if (parsed && parsed.length) return Promise.resolve(parsed);
      }
    } catch (e) { /* private window, blocked storage: just fetch */ }

    var pages = Math.max(1, Math.ceil((cfg.cat_count || 0) / (cfg.per || 250)));
    var urls = [], i;
    for (i = 1; i <= pages; i++) urls.push(cfg.cat_url + (i > 1 ? '&page=' + i : ''));
    /* mode AND credentials MATCH THE PRELOAD in sections/sp-catalog.liquid, which
       is <link rel="preload" as="fetch" crossorigin="use-credentials">. A request
       that differs in either one is a DIFFERENT request to the browser, so the
       feed comes down twice - MEASURED on 25 October: with credentials
       'same-origin' here the console said "the request credentials mode does not
       match" and the 57 KB feed was fetched twice. The collection feed below has
       carried this same pair, and the same reasoning, since it was written. */
    return Promise.all(urls.map(function (u) {
      return fetch(u, { mode: 'cors', credentials: 'include' }).then(function (r) {
        if (!r.ok) throw new Error('sp-catalog: ' + u + ' answered ' + r.status);
        return r.json();
      });
    })).then(function (parts) {
      var all = [];
      parts.forEach(function (j) { if (j && j.items) all.push.apply(all, j.items); });
      all = all.filter(function (p) { return p.h !== 'test-ring'; });
      try { sessionStorage.setItem(key, JSON.stringify(all)); } catch (e) { /* full: no matter */ }
      return all;
    });
  };

  /* ----------------------------- the sliders ------------------------------ */
  /* Where each handle is, and the notches it moves between. A slider's own two
     ends (g._lo, g._hi) and its notch (g._step) are put on the group in
     index(); what the SHOPPER has chosen is in this.state.r, one { lo, hi }
     per slider, with nulls meaning "not narrowed at all". */

  Catalog.prototype.priceStep = function () {
    var n = parseFloat(this.cfg.price_step);
    if (isNaN(n) || n <= 0) n = 25;
    return n;
  };

  // The nearest notch on this slider, never outside its two ends.
  Catalog.prototype.snap = function (g, v) {
    var n = g._lo + Math.round((v - g._lo) / g._step) * g._step;
    if (n < g._lo) n = g._lo;
    if (n > g._hi) n = g._hi;
    return Math.round(n * 100) / 100;
  };

  Catalog.prototype.rangeLo = function (g) {
    var r = this.state.r[g.key];
    return (r && r.lo != null) ? r.lo : g._lo;
  };

  Catalog.prototype.rangeHi = function (g) {
    var r = this.state.r[g.key];
    return (r && r.hi != null) ? r.hi : g._hi;
  };

  /* IS THIS SLIDER A FILTER AT ALL? At its full span it is not: both handles
     on the collection's own ends means the shopper has said nothing, so there
     is no chip, nothing in the address bar, and keep() never asks it - which
     is what shows the rings that have no number for it at all. */
  Catalog.prototype.rangeOn = function (g) {
    var r = this.state.r[g.key];
    return !!(r && (r.lo != null || r.hi != null));
  };

  Catalog.prototype.money = function (n) {
    // The symbol is lifted off a price Shopify itself formatted, so it is right
    // in any currency without this file knowing anything about money formats.
    //
    // THE SECTION HANDS IT OVER NOW, worked out the same way off "0 | money
    // without trailing zeros" at the moment the page was rendered. The two
    // answers are the same in the same market - the feed is fetched from the
    // same storefront - but the section needs the symbol itself to write the
    // slider's two amounts, and one source cannot disagree with itself. The
    // old way is still here for anything that hands over no symbol.
    if (this.sym == null) {
      if (typeof this.cfg.money_sym === 'string' && this.cfg.money_sym !== '') this.sym = this.cfg.money_sym;
      else this.sym = (((this.items || [])[0] || {}).pf || '$0').replace(/[0-9].*$/, '');
    }
    return this.sym + group3(Math.round(n));
  };

  // What a slider's text and its chip both say: "$200 - $900", "4 mm - 8 mm".
  Catalog.prototype.rangeWords = function (g) {
    return g.amount(this, this.rangeLo(g)) + ' - ' + g.amount(this, this.rangeHi(g));
  };

  /* -------------------------------- the URL ------------------------------- */

  Catalog.prototype.readUrl = function () {
    var q = new URLSearchParams(location.search);
    var st = { f: {}, r: {}, sort: '', shown: 0 };
    TICKS.forEach(function (g) {
      var raw = q.get('spf_' + g.key);
      st.f[g.key] = raw ? raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean) : [];
    });
    /* A SLIDER IN THE ADDRESS BAR IS TWO NUMBERS JOINED BY ONE DASH, AND
       NOTHING ELSE - spf_price=200-900, spf_width=4-8. Anything else is an old
       link and is dropped WHOLE rather than half understood, so the shopper
       gets every ring instead of a silently wrong range:
         - the price bands this replaced wrote several pairs joined with a bar,
           sometimes with an end missing ("0-200|1500-");
         - Width was a list of ticks until 22 October, so its old links carry
           names: "7 mm", or "6 mm|7 mm" for two of them.
       Both halves have to be a plain number (plainNum above), which is what
       keeps "7 mm-8 mm" out as well.
       A link for a group this collection does not draw, or a range that covers
       the whole slider, is settled in index() a moment later. */
    SLIDE.forEach(function (g) {
      var cur = { lo: null, hi: null };
      st.r[g.key] = cur;
      var raw = q.get('spf_' + g.key);
      if (!raw || raw.indexOf('|') >= 0) return;
      var bits = raw.split('-');
      if (bits.length !== 2 || !plainNum(bits[0]) || !plainNum(bits[1])) return;
      var a = parseFloat(bits[0]), b = parseFloat(bits[1]);
      cur.lo = Math.min(a, b);
      cur.hi = Math.max(a, b);
    });
    /* THE SORT OUT OF THE ADDRESS. Anything this file does not know how to do -
       an old link, a hand-typed word, one of Shopify's own names we do not
       offer - becomes the page's default rather than being kept: a sort the
       <select> has no option for would leave the Sort box showing nothing at
       all, which is worse than quietly starting at Featured. */
    st.sort = q.get('sort_by') || '';
    if (SORT_OK.indexOf(st.sort) < 0) st.sort = this.cfg.sort_default || 'manual';
    var shown = parseInt(q.get('spn'), 10);
    var page = parseInt(q.get('page'), 10);
    if (shown > 0) st.shown = shown;
    else if (page > 1) st.shown = page * this.cfg.first_page;
    return st;
  };

  Catalog.prototype.anyFilter = function (st) {
    st = st || this.state;
    for (var i = 0; i < SLIDE.length; i++) {
      var r = st.r[SLIDE[i].key];
      if (r && (r.lo != null || r.hi != null)) return true;
    }
    for (var k in st.f) { if (st.f[k] && st.f[k].length) return true; }
    return false;
  };

  Catalog.prototype.countFilters = function () {
    var st = this.state, self = this, k, n = 0;
    SLIDE.forEach(function (g) { n += self.chosenCount(g.key); });
    for (k in st.f) n += st.f[k].length;
    return n;
  };

  // How many choices are sitting in one group - what a shut group's header
  // says. A narrowed slider is one choice, so a shut Width group that has been
  // moved says "Width (1)", exactly as Price does.
  Catalog.prototype.chosenCount = function (key) {
    var st = this.state;
    if (st.r[key]) return (st.r[key].lo != null || st.r[key].hi != null) ? 1 : 0;
    return (st.f[key] || []).length;
  };

  Catalog.prototype.writeUrl = function () {
    var q = new URLSearchParams(location.search), st = this.state, self = this;
    TICKS.forEach(function (g) {
      if (st.f[g.key] && st.f[g.key].length) q.set('spf_' + g.key, st.f[g.key].join('|'));
      else q.delete('spf_' + g.key);
    });
    SLIDE.forEach(function (g) {
      if (self.rangeOn(g)) {
        q.set('spf_' + g.key, String(Math.round(self.rangeLo(g) * 100) / 100) + '-' +
                              String(Math.round(self.rangeHi(g) * 100) / 100));
      } else q.delete('spf_' + g.key);
    });
    if (st.sort) q.set('sort_by', st.sort); else q.delete('sort_by');
    if (st.shown > this.cfg.first_page) q.set('spn', String(st.shown)); else q.delete('spn');
    q.delete('page');
    var s = q.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash);
  };

  /* ------------------------------ getting data ---------------------------- */

  /* ------------------------- only rings that contain the word ------------- */

  /* THE SAME RULE snippets/sp-search-match.liquid KEEPS, DONE AGAIN HERE.

     Lorenzo, 25 October 2026, after searching "Stripe" and being shown rings
     with nothing to do with the word: "Show only rings that contain the search
     word, in the suggestions and on the search page, and fall back to Shopify's
     list when nothing matches."

     WHY THE THEME HAS TO: /search/suggest.json?q=stripe came back with ten
     products of which TWO contained "stripe" anywhere. Shopify pads a product
     search with rings it judges similar - the Ajax documentation says product
     results "always search all of the product properties", and even "qwzx"
     brings a ring back - and a theme cannot switch that off. So the padding is
     taken off here.

     THE RULE, WORD FOR WORD WITH THE SNIPPET:
       the text of a ring is its title (t), its tags (g), its materials (m), its
       type (y) and every option value (o), run together and lower-cased - and
       NOT its description, which is where the weak matches come from and which
       Shopify has already searched;
       the words of the query arrive already cleaned in cfg.search_words, with
       the filler words in cfg.search_fillers taken out by that same snippet;
       a ring matches when EVERY word is a substring of its text, and a word
       that is not found is tried again without a trailing "es" and then without
       a trailing "s", so "opals" finds "opal";
       if NO ring matches, Shopify's list is left exactly as it is, which is what
       keeps a typo like "meteroite" working.

     THE FILLER LIST IS NOT COPIED INTO THIS FILE. It is rendered into the
     config from the snippet, so there is one list and it cannot drift. */
  /* THE RULE ITSELF IS assets/sp-search-match.js NOW - 25 October 2026, when the
     header's suggestions needed the same rule and a second copy would have been a
     second rule waiting to disagree. sections/sp-catalog.liquid loads it just
     before this file, both deferred, so it is here by the time anything below
     runs. If it is NOT - the file failed to load - every search falls back to
     Shopify's own list unfiltered, which is what the shop did before any of this,
     and nothing on the page breaks. */
  function matcher() { return window.SestoSearchMatch || null; }

  /* THE BROWSER TAB SAYS THE SAME NUMBER THE PAGE DOES. Lorenzo, 25 October
     2026: "Yes match it". Shopify writes the title with its own count ("Search:
     21 results found for stripe"), counted before the rings it padded in are
     taken out, so that number is swapped for the count of rings this page
     really shows. Only a number followed by "result" or "results" is touched, so
     a title in another language is left as Shopify wrote it; when nothing
     matched, Shopify's list and its title both stand. */
  function retitle(n) {
    var was = document.title;
    var now = was.replace(/\d[\d,.]*(\s+)results?\b/i, function (all, gap) {
      return n + gap + (n === 1 ? 'result' : 'results');
    });
    if (now !== was) document.title = now;
  }

  /* The words this search is looking for, already cleaned by
     snippets/sp-search-match.liquid and carried in the page's config. */
  Catalog.prototype.searchWords = function () {
    return String(this.cfg.search_words || '').split(' ').filter(function (w) { return w; });
  };

  /* Everything in `list` that matches, in the order given. */
  Catalog.prototype.onlyMatching = function (list) {
    var M = matcher();
    var words = this.searchWords();
    if (!M || !words.length) return list;
    return M.keep(list, words);
  };

  /* RELEVANCE, WHEN THE RINGS CAME OUT OF THE CATALOGUE - 25 October 2026.
     The catalogue arrives in the shop's own order, which means nothing to
     somebody who typed a word, so the order is made here: a ring whose TITLE
     carries every word first, then the rest, and each of those two groups in
     BEST-SELLING order - the same order feed the collection pages already use,
     2.9 KB for the whole shop.

     WHY TITLE FIRST: somebody who types "stripe" means The Stripe before a ring
     that merely has a stripe somewhere in its tags. Within a group best-selling
     is the only ordering the shop already trusts; alphabetical would put "11140"
     above The Meteor.

     IF THE ORDER FEED DOES NOT ARRIVE the two groups still hold and the rings
     inside them keep the catalogue's own order, which is no worse than before. */
  Catalog.prototype.byRelevance = function (list) {
    var M = matcher();
    var words = this.searchWords();
    var best = this.best || {};
    if (!M || !words.length) return list;
    var rank = list.map(function (p, i) {
      var b = best[p.h];
      return { p: p, g: M.titleHit(p, words) ? 0 : 1, b: (b == null ? 1e9 : b), i: i };
    });
    rank.sort(function (a, b) { return a.g - b.g || a.b - b.b || a.i - b.i; });
    return rank.map(function (r) { return r.p; });
  };

  Catalog.prototype.cacheKey = function () {
    return 'spcat:' + this.cfg.handle + ':' + this.cfg.count + ':' + VER;
  };

  /* THE CATALOGUE'S OWN KEY IS THE ONE /collections/all WOULD USE, on purpose:
     one download then serves the search page AND that collection page, and a
     second search in the same tab asks the server for nothing at all. */
  Catalog.prototype.catKey = function () {
    return 'spcat:' + this.cfg.cat_handle + ':' + this.cfg.cat_count + ':' + VER;
  };

  Catalog.prototype.load = function () {
    var self = this, key = this.cacheKey();
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) {
        var parsed = JSON.parse(hit);
        if (parsed && parsed.length) { this.items = parsed; return Promise.resolve(); }
      }
    } catch (e) { /* private window, blocked storage: just fetch */ }

    var pages = Math.max(1, Math.ceil(this.cfg.count / this.cfg.per));
    var urls = [], i;
    for (i = 1; i <= pages; i++) urls.push(this.cfg.data_url + (i > 1 ? '&page=' + i : ''));

    /* THE SAME REQUEST THE SECTION HAS ALREADY STARTED.

       sections/sp-catalog.liquid makes a <link rel="preload" as="fetch"
       crossorigin="use-credentials"> for each of these pages near the top of
       the page, so the browser starts downloading the feed while it is still
       reading the HTML instead of waiting for this deferred script to run.
       MEASURED before that link existed: the requests started at 601 to 631 ms
       over three runs - every time the moment this script ran. After: 295 to
       482 ms. It only makes the links when this collection is NOT already in
       sessionStorage, which is why the lines above still come first: a second
       page view in the same tab asks the server for nothing at all.

       FOR THE BROWSER TO HAND THE PRELOADED ANSWER OVER, THE FETCH HAS TO BE
       THE SAME REQUEST: the same URL, the same mode and the same credentials,
       or the feed is simply downloaded twice. crossorigin="use-credentials" is
       a cors-mode request that DOES send the cookies, so this says
       credentials: 'include' - which on a same-origin URL sends exactly what
       'same-origin' sent before. The cookies are the reason it is
       use-credentials and not anonymous: they carry the market, and the feed
       writes every price out in the market's own money, so a cookie-less feed
       could have come back in another currency than the page it belongs to. */
    return Promise.all(urls.map(function (u) {
      return fetch(u, { mode: 'cors', credentials: 'include' }).then(function (r) {
        if (!r.ok) throw new Error('sp-catalog: ' + u + ' answered ' + r.status);
        return r.text();
      });
    })).then(function (texts) {
      var all = [];
      texts.forEach(function (t) {
        var j = JSON.parse(t);
        if (j && j.items) all.push.apply(all, j.items);
      });
      // product-grid-item.liquid skips the handle 'test-ring', so we do too -
      // otherwise the count here would be one more than the grid shows.
      self.items = all.filter(function (p) { return p.h !== 'test-ring'; });
      try { sessionStorage.setItem(key, JSON.stringify(self.items)); } catch (e) { /* full: no matter */ }
    });
  };

  Catalog.prototype.loadBest = function () {
    return this.loadBestFor(this.cfg.handle, this.cfg.count, this.cfg.order_url);
  };

  /* The same fetch, told WHOSE order to get: a collection's own, or - on a search
     whose rings came out of the catalogue - the catalogue's. */
  Catalog.prototype.loadBestFor = function (handle, count, orderUrl) {
    var self = this;
    if (this.best) return Promise.resolve();
    if (!orderUrl) return Promise.reject(new Error('sp-catalog: no order feed'));
    var key = 'spcat-best:' + handle + ':' + count + ':' + VER;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) { this.best = JSON.parse(hit); return Promise.resolve(); }
    } catch (e) { /* ignore */ }
    var pages = Math.max(1, Math.ceil(count / this.cfg.per));
    var urls = [], i;
    for (i = 1; i <= pages; i++) urls.push(orderUrl + '&sort_by=best-selling' + (i > 1 ? '&page=' + i : ''));
    return Promise.all(urls.map(function (u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('sp-catalog: ' + u + ' answered ' + r.status);
        return r.text();
      });
    })).then(function (texts) {
      var pos = {}, n = 0;
      texts.forEach(function (t) {
        var j = JSON.parse(t);
        (j && j.h ? j.h : []).forEach(function (h) { pos[h] = n++; });
      });
      self.best = pos;
      try { sessionStorage.setItem(key, JSON.stringify(pos)); } catch (e) { /* ignore */ }
    });
  };

  /* --------------------------- reading the rings -------------------------- */

  Catalog.prototype.index = function () {
    var items = this.items, self = this;

    items.forEach(function (p, ix) {
      var f = {};
      GROUPS.forEach(function (g) { f[g.key] = []; });

      var tags = (p.g || []).map(function (t) { return { raw: t, low: String(t).toLowerCase() }; });

      GROUPS.forEach(function (g) {
        (g.tags || []).forEach(function (pre) {
          var pl = pre + '_';
          tags.forEach(function (t) {
            if (t.low.indexOf(pl) === 0) uniqPush(f[g.key], canon(g, t.raw.slice(pl.length)));
          });
        });
        (g.opts || []).forEach(function (name) {
          (p.o || []).forEach(function (o) {
            if (String(o.n).toLowerCase() === name) {
              (o.v || []).forEach(function (v) { uniqPush(f[g.key], canon(g, v)); });
            }
          });
        });
      });

      p._f = f;
      p._sale = p.q > p.p;
      p._pr = p.p / 100;
      p._t = String(p.t || '').toLowerCase();
      // WHERE THIS RING SAT IN THE FEED. Availability and % Sale off both keep
      // the page's own order inside a group rather than falling back to the
      // title, so they need to know it. Array.prototype.sort is stable in every
      // browser this theme supports, but leaning on that is a silent thing to
      // lean on - this makes it the comparator's own business.
      p._i = ix;
      // HOW BIG THE SAVING IS, as a fraction of the compare-at price, from the
      // two numbers the feed already carries. -1, not 0, for a ring that is not
      // on sale, so "no saving" always loses to a real saving of 0%.
      p._save = (p.q > p.p && p.q > 0) ? (p.q - p.p) / p.q : -1;
      // Every slider's numbers for this ring, read the one way its own
      // description says. _pr first, because Price's description reads it.
      var n = {};
      SLIDE.forEach(function (g) { n[g.key] = g.vals(p); });
      p._n = n;
    });

    // Which groups carry information? A tick group needs two different values,
    // or it tells a shopper nothing and is not drawn at all; a slider works out
    // its own two ends and answers the same question for itself.
    this.groups = GROUPS.filter(function (g) {
      if (g.slider) return self.sliderEnds(g);
      var vals = [], counts = {};
      items.forEach(function (p) {
        p._f[g.key].forEach(function (v) {
          uniqPush(vals, v);
          counts[v] = (counts[v] || 0) + 1;
        });
      });
      g._vals = vals;
      g._counts = counts;
      return vals.length >= 2;
    });

    // Drop anything in the address bar that this collection has no value for,
    // so a shared link from another collection cannot show an empty grid.
    var live = {};
    this.groups.forEach(function (g) { live[g.key] = g; });
    var st = this.state;
    TICKS.forEach(function (g) {
      if (!live[g.key]) { st.f[g.key] = []; return; }
      st.f[g.key] = st.f[g.key].filter(function (v) { return g._vals.indexOf(v) >= 0; });
    });
    /* A SLIDER'S RANGE FROM THE ADDRESS BAR is pulled onto the nearest notches
       and inside this collection's own two ends, so a 4 to 8 brought from
       another collection still means whole millimetres here. If it covers the
       whole slider it is not a filter at all, so no chip and nothing in the
       address bar; and a slider this collection does not draw is forgotten. */
    SLIDE.forEach(function (g) {
      var cur = st.r[g.key];
      if (!cur) return;
      if (!live[g.key]) { cur.lo = null; cur.hi = null; return; }
      if (cur.lo == null && cur.hi == null) return;
      var a = self.snap(g, self.rangeLo(g)), b = self.snap(g, self.rangeHi(g)), t;
      if (b < a) { t = a; a = b; b = t; }
      if (a <= g._lo && b >= g._hi) { cur.lo = null; cur.hi = null; }
      else { cur.lo = a; cur.hi = b; }
    });
  };

  /* A SLIDER'S TWO ENDS: the smallest and the largest number any ring in the
     WHOLE collection has for it, pushed outwards to a whole notch. They come
     from every ring and never from the filtered ones, so a slider always spans
     the whole collection and does not shrink under the shopper's finger while
     they are using it. MEASURED on His: prices 99 to 5229, so at a $25 notch
     the price slider runs 75 to 5250; widths 2 to 10 mm, so at a 1 mm notch
     the width slider runs 2 to 10.

     Answers false when the collection has nothing for this slider to say - no
     numbers at all, or fewer than two different ones on a slider that asks for
     two - and then the group is not drawn, which is the rule every tick group
     already lives by. */
  Catalog.prototype.sliderEnds = function (g) {
    var lo = null, hi = null, seen = [];
    g._step = g.step(this);
    if (!(g._step > 0)) g._step = 1;
    this.items.forEach(function (p) {
      p._n[g.key].forEach(function (v) {
        if (typeof v !== 'number' || isNaN(v)) return;
        if (lo === null || v < lo) lo = v;
        if (hi === null || v > hi) hi = v;
        if (seen.indexOf(v) < 0) seen.push(v);
      });
    });
    if (lo === null) return false;
    if (g.needTwo && seen.length < 2) return false;
    g._lo = Math.floor(lo / g._step) * g._step;
    g._hi = Math.ceil(hi / g._step) * g._step;
    if (g._hi <= g._lo) g._hi = g._lo + g._step;
    return true;
  };

  /* ------------------------------- filtering ------------------------------ */

  // skip: the one group to ignore, so a group's own counts are worked out
  // against every OTHER active filter. That is what makes the numbers honest.
  Catalog.prototype.keep = function (p, skip) {
    var st = this.state, i, g, sel, have, ok;
    for (i = 0; i < this.groups.length; i++) {
      g = this.groups[i];
      if (g.key === skip) continue;
      if (g.slider) {
        if (this.rangeOn(g) && !this.inRange(g, p)) return false;
        continue;
      }
      sel = st.f[g.key];
      if (!sel || !sel.length) continue;
      have = p._f[g.key];
      if (g.all) {
        for (var k = 0; k < sel.length; k++) if (have.indexOf(sel[k]) < 0) return false;
        continue;
      }
      ok = false;
      for (var j = 0; j < sel.length; j++) if (have.indexOf(sel[j]) >= 0) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  };

  /* ANY ONE OF THE RING'S NUMBERS BETWEEN THE TWO HANDLES, BOTH ENDS
     COUNTING. A width slider at 4 - 8 keeps a ring made in 4 mm and one made
     in 8 mm, and keeps a ring offered in 2 mm and 7 mm because of its 7. A
     price slider at 200 - 900 keeps a ring at exactly 200 and one at exactly
     900. (The price bands this replaced were lo <= price < hi.)

     A ring with NO number at all is left out while the slider is narrowed -
     MEASURED: 4 of His's 336 rings carry no width at all - and it comes back
     at the full range, because a slider at its full span is not a filter and
     keep() never asks this. */
  Catalog.prototype.inRange = function (g, p) {
    var lo = this.rangeLo(g), hi = this.rangeHi(g), vals = p._n[g.key], i;
    for (i = 0; i < vals.length; i++) {
      if (vals[i] >= lo && vals[i] <= hi) return true;
    }
    return false;
  };

  Catalog.prototype.filtered = function (skip) {
    var self = this;
    return this.items.filter(function (p) { return self.keep(p, skip); });
  };

  Catalog.prototype.facets = function () {
    var self = this, out = {};
    this.groups.forEach(function (g) {
      if (g.slider) return;                  // a slider has no values to count
      // A group that needs ALL its ticks is counted against its own ticks too,
      // so each number is what the page would show with that value ticked as
      // well. MEASURED on His: under Carbon Fiber, Wood reads 32 rather than 93.
      var base = self.filtered(g.all ? null : g.key), tally = {};
      base.forEach(function (p) {
        p._f[g.key].forEach(function (v) { tally[v] = (tally[v] || 0) + 1; });
      });
      out[g.key] = tally;
    });
    // No tally for a slider: it has no values to count. Every OTHER group's
    // counts above DO respect both sliders, because filtered(g.key) only ever
    // skips that one group's own choice - so the Material counts under a width
    // of 6 to 8 mm are the Material counts of those rings and nothing else.
    return out;
  };

  /* THE TEN SORTS, all of them done here from the feed that is already loaded,
     so every one of them is instant and asks Shopify for nothing. Only Best
     selling needs anything fetched, and that is an order Shopify alone knows.

     WHAT BREAKS A TIE, and it is not the same everywhere on purpose: the eight
     that sort by a number or a word fall back to the title, so two rings at the
     same price always come out in the same order. Availability and % Sale off
     fall back to the FEED position instead, because both of them split the
     rings into groups - can be bought or not, on sale or not - and inside a
     group the shopper should still see the page's own order rather than an
     alphabet. That is what was asked for and it is also the more useful of the
     two. */
  Catalog.prototype.sorted = function (arr) {
    var s = this.state.sort, best = this.best;
    function byTitle(a, b) { return a._t < b._t ? -1 : a._t > b._t ? 1 : 0; }
    function byFeed(a, b) { return a._i - b._i; }
    if (s === 'price-ascending')  return arr.slice().sort(function (a, b) { return a.p - b.p || byTitle(a, b); });
    if (s === 'price-descending') return arr.slice().sort(function (a, b) { return b.p - a.p || byTitle(a, b); });
    if (s === 'created-descending') return arr.slice().sort(function (a, b) { return b.d - a.d || byTitle(a, b); });
    if (s === 'created-ascending')  return arr.slice().sort(function (a, b) { return a.d - b.d || byTitle(a, b); });
    if (s === 'title-ascending')  return arr.slice().sort(byTitle);
    if (s === 'title-descending') return arr.slice().sort(function (a, b) { return byTitle(b, a); });
    // Availability: a ring that can be bought first. p.a is 1 or 0 in the feed.
    if (s === 'stock-descending') return arr.slice().sort(function (a, b) { return (b.a - a.a) || byFeed(a, b); });
    // % Sale off: the biggest saving first, everything not on sale after it.
    if (s === 'sale-descending')  return arr.slice().sort(function (a, b) { return (b._save - a._save) || byFeed(a, b); });
    if (s === 'best-selling' && best) {
      return arr.slice().sort(function (a, b) {
        var x = best[a.h], y = best[b.h];
        if (x == null) x = 1e9;
        if (y == null) y = 1e9;
        return x - y || byTitle(a, b);
      });
    }
    return arr;                              // Featured: the collection's own order
  };

  /* ------------------------------ the cards ------------------------------- */

  Catalog.prototype.srcset = function (url, w) {
    var join = url.indexOf('?') >= 0 ? '&' : '?', out = [];
    [360, 540, 720, 900, 1080].forEach(function (x) {
      if (x <= w) out.push(url + join + 'width=' + x + ' ' + x + 'w');
    });
    return out.length ? ' srcset="' + esc(out.join(', ')) + '"' : '';
  };

  Catalog.prototype.img = function (url, w, h, alt, cls) {
    return '<img src="' + esc(url) + '" alt="' + esc(alt) + '"' + this.srcset(url, w) +
      ' width="' + w + '" height="' + h + '" loading="lazy" class="' + cls +
      '" sizes="' + esc(this.cfg.sizes) + '">';
  };

  Catalog.prototype.card = function (p) {
    var C = this.cfg, sale = p._sale, disc = 0, cls = 'grid-product__content', dattr = '', tag = '';

    if (sale && C.enable_discount_badge) disc = Math.round((p.q - p.p) * 100 / p.q);
    if (disc > 0) {
      cls += ' grid-product__content--discount';
      if (disc >= C.discount_threshold) cls += ' grid-product__content--discount--accent';
      dattr = ' data-discount="' + disc + '% OFF"';
    }

    // The theme's own custom label: the theme.label metafield first, then a tag
    // that starts with an underscore and holds "_label_".
    var custom = p.lb || '';
    if (!custom) {
      (p.g || []).forEach(function (t) {
        if (String(t).charAt(0) === '_' && String(t).indexOf('_label_') >= 0) {
          custom = String(t).replace('_label_', '');
        }
      });
    }
    if (custom) tag = '<div class="grid-product__tag grid-product__tag--custom">' + esc(custom) + '</div>';
    else if (!p.a) tag = '<div class="grid-product__tag grid-product__tag--sold-out">' + esc(C.t_sold_out) + '</div>';
    else if (sale && C.product_save_badge) tag = '<div class="grid-product__tag grid-product__tag--sale">' + esc(C.t_sale) + '</div>';

    var icls = (C.product_grid_image_fill ? '' : ' grid__image-contain') + ' image-style--';
    var pic = '';
    if (p.i) {
      // p.ia is the picture's own alt and is EMPTY when it has none, which is
      // what snippets/image-element.liquid writes. The title is deliberately
      // NOT used instead: the link around the card already says it, so a screen
      // reader would hear the ring's name twice.
      if (C.product_grid_image_size !== 'natural') {
        pic = '<div class="grid__image-ratio grid__image-ratio--' + esc(C.product_grid_image_size) + '">' +
          this.img(p.i, p.iw, p.ih, p.ia, icls) + '</div>';
      } else {
        pic = '<div class="image-wrap" style="height: 0; padding-bottom: ' +
          (Math.round(10000 * p.ih / p.iw) / 100) + '%;">' +
          this.img(p.i, p.iw, p.ih, p.ia, 'grid-product__image image-style--') + '</div>';
      }
    }
    // The hover picture is the same ring again, so it is given no alt words on
    // purpose - a screen reader should not read the ring out twice.
    var pic2 = (C.product_hover_image && p.j)
      ? '<div class="grid-product__secondary-image small--hide">' + this.img(p.j, p.jw, p.jh, '', 'image-style--') + '</div>'
      : '';

    var price = '';
    if (sale && p.qf) {
      price += '<span class="visually-hidden">' + esc(C.t_regular) + '</span>' +
        '<span class="grid-product__price--original">' + esc(p.qf) + '</span>' +
        '<span class="visually-hidden">' + esc(C.t_sale_price) + '</span>';
    }
    price += p.v
      ? 'from <span class="price price111">' + esc(p.pf) + ' </span>'
      : '<span class="price">' + esc(p.pf) + ' </span>';

    var vendor = (C.vendor_enable && p.vn) ? '<div class="grid-product__vendor">' + esc(p.vn) + '</div>' : '';
    var mats = p.m ? '<div><p class="product-mats">' + esc(p.m) + '</p></div>' : '';

    /* THE STAR RATING, OURS - 1 November 2026, issue #68. This used to build the
       two empty Fera boxes that snippets/product-grid-item.liquid puts between
       the title and the materials line, for Fera's script to fill. Lorenzo is
       having the app uninstalled, so the stars are drawn here instead, from the
       feed: p.r is the stored average to one decimal and p.rc the count
       (sesto_reviews.rating / .count, written by
       templates/collection.sp-catalog-data.liquid). Both keys are LEFT OUT of
       the feed when a ring has no reviews of its own, so nothing is drawn and
       the card is exactly as tall as a server-drawn one - no reviews, no stars
       (Lorenzo, 26 October 2026).

       THE MARKUP AND THE CLASSES ARE THAT SNIPPET'S, WORD FOR WORD, including
       the single space before the count: change one, change the other. The look
       is in assets/custom.css under .sp-stars. The width is written with one
       decimal (100.0, 96.0) because that is what Liquid prints, so a card drawn
       here and a card drawn there carry the same string. */
    var stars = '';
    if (p.rc > 0) {
      var fillPct = (Math.max(0, Math.min(5, Number(p.r) || 0)) * 20).toFixed(1);
      stars = '<div class="sp-stars" role="img" aria-label="' + (Number(p.r) || 0).toFixed(1) +
        ' out of 5 stars, ' + esc(p.rc) + ' review' + (p.rc === 1 ? '' : 's') + '">' +
        '<span class="sp-stars__stars">' +
        '<span class="sp-stars__fill" style="width:' + fillPct + '%">\u2605\u2605\u2605\u2605\u2605</span>' +
        '<span class="sp-stars__bg"></span></span> ' +
        '<span class="sp-stars__n">' + esc(p.rc) + '</span></div>';
    }

    return '<div class="grid__item grid-product ' + esc(C.item_class) +
      '" data-product-handle="' + esc(p.h) + '" data-product-id="' + esc(p.id) + '">' +
      '<div class="' + cls + '"' + dattr + '>' + tag +
      '<a href="' + esc(C.collection_url + '/products/' + p.h) + '" class="grid-product__link">' +
      '<div class="grid-product__image-mask">' + pic + pic2 + '</div>' +
      '<div class="grid-product__meta">' +
      '<div class="grid-product__title grid-product__title--' + esc(C.type_product_style) + '">' + esc(p.t) + '</div>' +
      stars + mats + vendor +
      '<div class="grid-product__price">' + price + '</div>' +
      '</div></a></div></div>';
  };

  /* ---------------------------- drawing the page -------------------------- */

  /* EVERY VALUE THE GROUP HAS, IN ORDER. Lorenzo, 22 October: "show all by
     default" - so there is nothing to slice off the end and no words to narrow
     it by, and what sortValues gives back is what is drawn.

     A VALUE THAT WOULD GIVE NO RINGS IS HIDDEN, NOT FADED, and what is left
     closes up. Lorenzo, 31 October: "Cna we hide the matersial that dont apply
     after a filter instead of making them geryed out", then of Profile and
     Width, "Yes hide those too". A ticked value always stays, or it could not
     be unticked. It is the class is-gone and not a value left out of the html,
     because the first draw keeps the server's own pictures only when both
     lists hold the same values - see paintInto. */
  Catalog.prototype.valueRows = function (g, facets, cardStyle) {
    var st = this.state, tally = facets[g.key] || {}, self = this;
    var vals = sortValues(g, g._vals);

    var html = vals.map(function (v, ix) {
      var n = tally[v] || 0, on = st.f[g.key].indexOf(v) >= 0, gone = n === 0 && !on;
      // The index is in the id because two different values can come down to
      // the same letters - "T-Rex" and "T - Rex" are both in the shop - and two
      // boxes with one id would tick each other.
      var id = 'spc-' + self.cfg.uid + '-' + cardStyle + '-' + g.key + '-' + ix;
      /* A SWATCH TILE: the same real checkbox, with a round picture where the
         tick box goes and the name under it. It is drawn the same in the
         sidebar and in the phone's panel - a tile is a tile - so it does not
         take the --card class, which is the phone's look for a ROW. The chosen
         look is the cream and the tan edge the rest of the filter uses, with a
         gold ring round the picture; a value giving 0 takes is-gone, exactly
         as a row does. */
      if (g.swatch) {
        return '<label class="sp-catalog__val sp-catalog__sw' +
          (on ? ' is-on' : '') + (gone ? ' is-gone' : '') + '" for="' + esc(id) + '">' +
          '<input type="checkbox" class="sp-catalog__cb" id="' + esc(id) + '" data-sp-val="' + esc(g.key) +
          '" value="' + esc(v) + '"' + (on ? ' checked' : '') + '>' +
          self.swatchPic(g.key, v) +
          '<span class="sp-catalog__vname">' + esc(v) + '</span>' +
          '<span class="sp-catalog__vn">' + n + '</span></label>';
      }
      return '<label class="sp-catalog__val' + (cardStyle === 'card' ? ' sp-catalog__val--card' : '') +
        (on ? ' is-on' : '') + (gone ? ' is-gone' : '') + '" for="' + esc(id) + '">' +
        '<input type="checkbox" class="sp-catalog__cb" id="' + esc(id) + '" data-sp-val="' + esc(g.key) +
        '" value="' + esc(v) + '"' + (on ? ' checked' : '') + '>' +
        '<span class="sp-catalog__box" aria-hidden="true"></span>' +
        '<span class="sp-catalog__vname">' + esc(v) + '</span>' +
        '<span class="sp-catalog__vn">' + n + '</span></label>';
    }).join('');

    /* The tiles go in a grid of their own, which is what lets the computer's
       sidebar put four across and the phone's panel as many as fit. */
    if (g.swatch) {
      html = '<div class="sp-catalog__swgrid sp-catalog__swgrid--' + esc(g.key) + '">' + html + '</div>';
    }

    return html;
  };

  /* ------------------------- a value's own picture ------------------------ */
  /* THE PICTURES ARE THEME ASSETS, not Globo's image server. The section reads
     assets/sp-swatch-<group>-<name>.<jpg|png> through asset_url and hands them
     over in data-sp-config as swatch[group][name in lower case] = [url, width,
     height], so the filter keeps its pictures the day the app is removed and
     nothing on the page asks another company's server for anything.

     A name the theme has no picture for gets a cream circle with its first
     letter instead. It is not an error and nothing is hidden: a new
     Material_ tag can be made in Shopify at any time, and it still gets a tile
     a shopper can tick. MEASURED: all 14 Material values and all 4 Profile
     values on His have a picture, and so do the same values on Custom Wedding
     Rings. */
  Catalog.prototype.swatchOf = function (key, v) {
    var all = this.cfg.swatch || {}, one = all[key] || {};
    var s = one[String(v == null ? '' : v).toLowerCase()];
    return (s && s[0]) ? s : null;
  };

  // aria-hidden and an empty alt because the name is written beside it in
  // words; read out, the tile would otherwise say the material twice. lazy
  // because a group can hold fourteen of them and the phone's panel is shut.
  Catalog.prototype.swatchPic = function (key, v) {
    var s = this.swatchOf(key, v);
    if (!s) {
      return '<span class="sp-catalog__swpic sp-catalog__swpic--none" aria-hidden="true">' +
        esc(String(v == null ? '' : v).charAt(0).toUpperCase()) + '</span>';
    }
    return '<span class="sp-catalog__swpic" aria-hidden="true">' +
      '<img src="' + esc(s[0]) + '" width="' + esc(s[1]) + '" height="' + esc(s[2]) +
      '" alt="" loading="lazy" decoding="async"></span>';
  };

  /* The inside of one group, whichever kind of group it is. This one line is
     all that drawFilters has to know about the difference between a slider and
     a list of ticks. */
  Catalog.prototype.groupBody = function (g, facets, cardStyle) {
    return g.slider ? this.sliderHtml(g, cardStyle) : this.valueRows(g, facets, cardStyle);
  };

  /* THE SEARCH BOX INSIDE A GROUP IS GONE, and with it the box the values used
     to sit in - that box only ever existed so typing could rewrite one list
     without throwing away the input the shopper was typing in. Lorenzo, 22
     October: "Remove the search within the options". canFind, findHtml,
     groupInner, typeFind and the words kept per group all went; commit 12a2eca
     holds every one of them. */

  /* ------------------------------ the sliders ----------------------------- */
  /* ONE SET OF FUNCTIONS FOR BOTH SLIDERS. Everything that differs between
     Price and Width is in that slider's description (SLIDERS at the top of the
     file); everything below works whichever one it is handed, and the two
     never touch each other's handles - each keeps its own pending pair and its
     own 150 ms timer, by key.

     TWO PLAIN RANGE INPUTS, ONE ON TOP OF THE OTHER. No library, and nothing
     clever: the inputs themselves take no pointer events, only their handles do
     (the CSS in sections/sp-catalog.liquid), so a finger or a mouse lands on
     whichever handle is under it and the shopper drags that one. Because they
     are real inputs they are in the tab order and the arrow keys move a handle,
     which is the whole reason for building it this way rather than out of divs.

     The handles cannot cross: the one being dragged stops dead at the other
     (sliderInput below). They can sit on the same notch, which is a fair thing
     to ask for - one price.

     TWO HANDLES ON THE SAME NOTCH CAN HIDE EACH OTHER, and one of those pairs
     would otherwise be a dead end: both pinned at the dearest end, with the top
     handle unable to come down because the one under it is in the way. Two
     things deal with it. The handle in the upper half is drawn on top, so the
     one that CAN move away from the pile is always the one a finger reaches;
     and a tap anywhere on the rail moves the nearer handle to that spot
     (sliderTap), which is a way out of any pile and a quicker way to set a
     price besides. */

  Catalog.prototype.sliderHtml = function (g, cardStyle) {
    var lo = this.rangeLo(g), hi = this.rangeHi(g);
    var span = (g._hi - g._lo) || 1;
    var id = 'spc-' + this.cfg.uid + '-' + cardStyle + '-' + g.key;
    var common = ' min="' + g._lo + '" max="' + g._hi + '" step="' + g._step + '"';
    var top = lo > (g._lo + g._hi) / 2;            // see the note above
    /* data-sp-slider names BOTH the list it is in and which slider it is -
       "row-price", "card-width" - because drawFilters puts a handle the shopper
       is holding with the keyboard back by that name, and with two sliders in
       each of the two lists the list alone would no longer say which one. */
    return '<div class="sp-catalog__slider" data-sp-slider="' + esc(cardStyle + '-' + g.key) +
      '" data-sp-sliderkey="' + esc(g.key) + '">' +
      '<div class="sp-catalog__sliderrail" data-sp-rail>' +
      '<span class="sp-catalog__sliderfill" data-sp-fill style="left: ' +
        ((lo - g._lo) * 100 / span) + '%; right: ' + ((g._hi - hi) * 100 / span) + '%;"></span>' +
      '<input type="range" class="sp-catalog__range" data-sp-range="min" id="' + esc(id) + '-min"' +
        common + ' value="' + lo + '" style="z-index: ' + (top ? 4 : 3) + ';" aria-label="' + esc(g.ends[0]) + '">' +
      '<input type="range" class="sp-catalog__range" data-sp-range="max" id="' + esc(id) + '-max"' +
        common + ' value="' + hi + '" style="z-index: ' + (top ? 3 : 4) + ';" aria-label="' + esc(g.ends[1]) + '">' +
      '</div>' +
      '<p class="sp-catalog__sliderval" data-sp-sliderval>' + esc(this.rangeWords(g)) + '</p>' +
      '</div>';
  };

  // Which slider an input or a rail belongs to: its own wrapper says so, so a
  // handle can never be worked out as the other slider's.
  Catalog.prototype.sliderOf = function (el) {
    var wrap = (el && el.closest) ? el.closest('[data-sp-slider]') : null;
    if (!wrap) return null;
    var key = wrap.getAttribute('data-sp-sliderkey'), found = null;
    this.groups.forEach(function (g) { if (g.slider && g.key === key) found = g; });
    return found ? { g: found, wrap: wrap } : null;
  };

  // A tap on the rail itself, away from both handles: the nearer handle comes to
  // the tap. When they are on the same notch the one that can move towards the
  // tap is the one that goes, so no pile of handles is ever a dead end.
  Catalog.prototype.sliderTap = function (rail, clientX) {
    var box = rail.getBoundingClientRect();
    if (!box.width) return;
    var hit = this.sliderOf(rail);
    if (!hit) return;
    var g = hit.g;
    var a = $('[data-sp-range="min"]', rail), b = $('[data-sp-range="max"]', rail);
    if (!a || !b) return;
    var at = this.snap(g, g._lo + ((clientX - box.left) / box.width) * (g._hi - g._lo));
    var lo = parseFloat(a.value), hi = parseFloat(b.value);
    var pick = (at <= lo) ? a : (at >= hi) ? b : (((at - lo) <= (hi - at)) ? a : b);
    pick.value = String(at);
    this.sliderInput(pick);
    this.sliderCommit(pick);
  };

  Catalog.prototype.sliderPaint = function (wrap, g, lo, hi) {
    var span = (g._hi - g._lo) || 1;
    var fill = $('[data-sp-fill]', wrap), txt = $('[data-sp-sliderval]', wrap);
    if (fill) {
      fill.style.left = ((lo - g._lo) * 100 / span) + '%';
      fill.style.right = ((g._hi - hi) * 100 / span) + '%';
    }
    if (txt) txt.textContent = g.amount(this, lo) + ' - ' + g.amount(this, hi);
  };

  // While a handle is moving: that slider's two amounts and the gold part of
  // its own track keep up, and nothing else is touched at all. The rings wait
  // for sliderCommit. Answers which slider it was, so the commit knows.
  Catalog.prototype.sliderInput = function (r) {
    var hit = this.sliderOf(r);
    if (!hit) return null;
    var g = hit.g, wrap = hit.wrap;
    var a = $('[data-sp-range="min"]', wrap), b = $('[data-sp-range="max"]', wrap);
    if (!a || !b) return null;
    var lo = parseFloat(a.value), hi = parseFloat(b.value);
    if (lo > hi) {                       // they must not cross
      if (r === a) { lo = hi; a.value = String(hi); }
      else { hi = lo; b.value = String(lo); }
    }
    // The handle last touched is drawn on top, so two handles sitting on the
    // same notch can both still be picked up.
    a.style.zIndex = (r === a) ? '4' : '3';
    b.style.zIndex = (r === b) ? '4' : '3';
    this.sliderPaint(wrap, g, lo, hi);
    // One pending pair PER SLIDER, so a width being dragged cannot land on the
    // price slider's handles or the other way about.
    this._pending[g.key] = { lo: lo, hi: hi };
    return g;
  };

  /* WHEN THE RINGS CATCH UP: on the handle being let go, not while it moves.

     THE REASON IS NOT THAT IT IS SLOW. MEASURED at 375 on His, five runs, from
     the change event to the count on the screen actually changing: 198, 205,
     209, 211, 202 ms, which is 48 to 61 ms of real work once the 150 ms wait
     below is taken off. That is under the 100 ms that would make a live redraw
     feel like nothing.

     The reason is that the redraw REBUILDS THE CONTROL. drawFilters() rewrites
     both filter lists whole, so a redraw in the middle of a drag would throw
     away the very input the shopper has hold of. So the rings wait for the
     finger to lift. (To make it live, a slider's group would have to be left
     alone by drawFilters and updated in place - worth doing if he asks.)

     The 150 ms is for the keyboard, not the finger: a range input fires change
     on EVERY arrow key, so a held-down arrow would otherwise queue one full
     redraw per notch. */
  Catalog.prototype.sliderCommit = function (r) {
    var self = this;
    var g = this.sliderInput(r);         // in case a change arrived with no input
    if (!g) return;
    var v = this._pending[g.key];
    if (!v) return;
    if (this._timers[g.key]) clearTimeout(this._timers[g.key]);
    this._timers[g.key] = setTimeout(function () {
      // Both handles back on the collection's own ends is not a filter: the
      // chip goes, the address bar is emptied of it, and the rings that have
      // no number for this slider are shown again.
      var whole = v.lo <= g._lo && v.hi >= g._hi;
      self.state.r[g.key].lo = whole ? null : v.lo;
      self.state.r[g.key].hi = whole ? null : v.hi;
      self.change();
    }, 150);
  };

  /* THE OFFER AND AVAILABILITY ROWS ARE GONE. Lorenzo, 22 October, asked for
     the live theme's own groups less Thickness, and On sale and In stock are
     not among them. They were the only two rows drawn beside GROUPS rather
     than from it, so GROUPS is now the whole of the filter column: what is
     drawn, and in what order. Their code is in git (commit e5ba307 of this
     file holds extraRows and the sale and stock halves of readUrl, writeUrl,
     keep, facets, drawChips and clearAll). spf_sale= and spf_stock= in an old
     link are read by nothing now. */

  Catalog.prototype.groupShell = function (key, label, inner, cardStyle) {
    /* HOW A GROUP STARTS: OPEN, in both lists. Lorenzo, 21 October, looking at
       his phone: "Can we have the options on the mobile collapsed by default" -
       and then on 22 October, having looked at that: "show all by default and
       expanded by default". The second asks for the opposite of the first, so
       the phone's panel now starts open exactly as the computer's sidebar always
       has, and cardStyle does not come into it any more.

       openGroups holds only the groups the shopper has SHUT, or shut and opened
       again, by hand. It lives in memory, so a group they shut stays shut while
       the panel is closed and opened again, and every group is open again on the
       next page load. */
    var open = this.openGroups[key];
    if (open === undefined) open = true;
    // A shut group with ticks in it says how many, or they are invisible:
    // "Material (2)". Only in the panel; nothing on the computer changes.
    var chosen = (!open && cardStyle === 'card') ? this.chosenCount(key) : 0;
    var id = 'spc-' + this.cfg.uid + '-' + cardStyle + '-grp-' + key;
    return '<div class="sp-catalog__group' + (open ? ' is-open' : '') + '" data-sp-group="' + esc(key) + '">' +
      '<h3 class="sp-catalog__grouphead">' +
      '<button type="button" class="sp-catalog__grouptoggle" data-sp-toggle="' + esc(key) + '"' +
      ' aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="' + esc(id) + '">' +
      '<span class="sp-catalog__grouplabel">' + esc(label) +
      (chosen ? ' <span class="sp-catalog__groupn">(' + chosen + ')</span>' : '') + '</span>' +
      '<svg class="sp-catalog__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="5 9 12 16 19 9"/></svg>' +
      '</button></h3>' +
      '<div class="sp-catalog__groupbody" id="' + esc(id) + '"' + (open ? '' : ' hidden') + '>' + inner + '</div></div>';
  };

  /* ------------- putting a list up without moving what is there ------------ */
  /* THE FILTER IS ALREADY ON THE SCREEN WHEN THIS FILE FIRST RUNS. Lorenzo, 23
     October: "There is a dealy in loading he filter when the page loas. How can
     we make it load faster along with the rest of the page" - so
     sections/sp-catalog.liquid now draws the four groups in the HTML itself,
     with the same markup written below, and marks the two lists with
     data-sp-server.

     Writing innerHTML over that would throw away eighteen pictures and build
     them again, which is a flicker and a chance for the column to move. So on
     that FIRST draw each group is compared with the one the server drew, group
     by group:

       the same values in the same order  ->  only the counts, the hidden state
                                              and the ticks are changed, and
                                              every other node - every picture,
                                              every name, every box - stays
                                              exactly where it is;
       anything else                      ->  that ONE group is replaced, so a
                                              group the server could not draw
                                              never moves the other three.

     The price slider is always the second case: its two ends are the one thing
     Liquid cannot know (there is no collection.price_min), so the server draws
     the slider's box and handles and this replaces it with the real one. The
     box is the same size either way, so nothing moves.

     After this first pass the attribute is gone and every later draw is the
     plain innerHTML it always was. */
  Catalog.prototype.paintInto = function (box, parts) {
    var i, html = '';
    for (i = 0; i < parts.length; i++) html += parts[i].html;
    if (box.getAttribute('data-sp-server') !== '1') { box.innerHTML = html; return; }
    box.removeAttribute('data-sp-server');

    // The same groups in the same order, or there is nothing worth keeping.
    var have = $$('[data-sp-group]', box), ok = have.length === parts.length;
    for (i = 0; ok && i < parts.length; i++) {
      if (have[i].getAttribute('data-sp-group') !== parts[i].key) ok = false;
    }
    if (!ok) { box.innerHTML = html; return; }

    for (i = 0; i < parts.length; i++) {
      var tmp = document.createElement('div');
      tmp.innerHTML = parts[i].html;
      var fresh = tmp.firstChild;
      if (!fresh) continue;
      if (this.sameValues(have[i], fresh)) this.fillCounts(have[i], fresh);
      else have[i].parentNode.replaceChild(fresh, have[i]);
    }
  };

  // The same values in the same order, and no slider in either: a slider's two
  // ends are the thing the server cannot know, so a group holding one is always
  // replaced rather than patched.
  Catalog.prototype.sameValues = function (a, b) {
    if ($('[data-sp-range]', a) || $('[data-sp-range]', b)) return false;
    var x = $$('[data-sp-val]', a), y = $$('[data-sp-val]', b), i;
    if (!x.length || x.length !== y.length) return false;
    for (i = 0; i < x.length; i++) {
      if (x[i].getAttribute('data-sp-val') !== y[i].getAttribute('data-sp-val')) return false;
      if (x[i].getAttribute('value') !== y[i].getAttribute('value')) return false;
    }
    return true;
  };

  // What the data actually brought, and nothing else: the count, whether a
  // value would give no rings, and which values a shared link has ticked.
  Catalog.prototype.fillCounts = function (a, b) {
    if (a.className !== b.className) a.className = b.className;
    var x = $$('[data-sp-val]', a), y = $$('[data-sp-val]', b), i, la, lb, na, nb;
    for (i = 0; i < x.length; i++) {
      la = x[i].closest('.sp-catalog__val');
      lb = y[i].closest('.sp-catalog__val');
      if (la && lb && la.className !== lb.className) la.className = lb.className;
      if (x[i].checked !== y[i].checked) x[i].checked = y[i].checked;
      na = la ? $('.sp-catalog__vn', la) : null;
      nb = lb ? $('.sp-catalog__vn', lb) : null;
      if (na && nb && na.textContent !== nb.textContent) na.textContent = nb.textContent;
    }
  };

  Catalog.prototype.drawFilters = function (facets) {
    var self = this;

    var side = this.groups.map(function (g) {
      return { key: g.key, html: self.groupShell(g.key, g.label, self.groupBody(g, facets, 'row'), 'row') };
    });

    var panel = this.groups.map(function (g) {
      return { key: g.key, html: self.groupShell(g.key, g.label, self.groupBody(g, facets, 'card'), 'card') };
    });

    // Both lists are redrawn whole, so their scroll has to be put back by hand
    // - otherwise ticking the ninth Inlay on a phone throws the panel back to
    // the top and the shopper loses their place.
    var sTop = this.el.side ? this.el.side.scrollTop : 0;
    var pTop = this.el.panelBody ? this.el.panelBody.scrollTop : 0;

    /* A SLIDER HANDLE THE SHOPPER IS ALREADY HOLDING WITH THE KEYBOARD KEEPS
       THE KEYBOARD. Rewriting the list throws the old input away, so without
       this the first arrow key would move a handle and the second would go
       nowhere.

       THIS IS THE ONLY FOCUS THIS FILE EVER SETS, and it only ever puts it BACK
       where it already was. Nothing is focused on page load, when the panel
       opens, or when a group opens: Lorenzo's standing rule is that a screen
       never takes the keyboard by itself. A search box used to be put back the
       same way, with the cursor at the same letter; it went with the box. */
    var act = document.activeElement, back = null;
    if (act && act.getAttribute && this.root.contains(act)) {
      var rng = act.getAttribute('data-sp-range');
      if (rng) {
        var w = act.closest('[data-sp-slider]');
        if (w) back = '[data-sp-slider="' + w.getAttribute('data-sp-slider') + '"] [data-sp-range="' + rng + '"]';
      }
    }

    if (this.el.side) { this.paintInto(this.el.side, side); this.el.side.scrollTop = sTop; }
    if (this.el.panelBody) { this.paintInto(this.el.panelBody, panel); this.el.panelBody.scrollTop = pTop; }

    if (back) {
      var again = $(back, this.root);
      if (again) again.focus();
    }
  };

  Catalog.prototype.drawChips = function () {
    var st = this.state, self = this, out = [];
    /* Every group in the order it is drawn, so a chip sits where its group
       does: a narrowed slider is ONE chip saying what it is set to - "Width:
       4 mm - 8 mm", "Price: $200 - $900" - and its x puts that slider back to
       the collection's own two ends. */
    this.groups.forEach(function (g) {
      if (g.slider) {
        if (!self.rangeOn(g)) return;
        out.push('<button type="button" class="sp-catalog__chip" data-sp-chip="' + esc(g.key) +
          '" data-sp-chipval="1">' + esc(g.label) + ': ' + esc(self.rangeWords(g)) +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '<span class="visually-hidden"> - remove</span></button>');
        return;
      }
      st.f[g.key].forEach(function (v) {
        out.push('<button type="button" class="sp-catalog__chip" data-sp-chip="' + esc(g.key) +
          '" data-sp-chipval="' + esc(v) + '">' + esc(g.label) + ': ' + esc(v) +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '<span class="visually-hidden"> - remove</span></button>');
      });
    });
    /* THE SAME ROW, TWICE: on the page and at the top of the phone's panel.
       Lorenzo: "Show the filter selections on the top with option to remove
       same as we see them once the filter pan is closed." Same HTML, so the
       same chips, the same x on each and the same Clear all, and the one click
       handler on the section already works for both. Neither row is drawn when
       nothing is chosen. */
    if (out.length) out.push('<button type="button" class="sp-catalog__clear" data-sp-clear>Clear all</button>');
    var html = out.join('');
    [this.el.chips, this.el.panelChips].forEach(function (box) {
      if (!box) return;
      box.innerHTML = html;
      box.hidden = !html;
    });
  };

  // Does the grid still hold exactly these rings, in this order? True for the
  // rings Liquid drew when nothing has asked for anything else.
  Catalog.prototype.sameAsServer = function (show) {
    var have = $$('[data-product-handle]', this.el.grid);
    if (have.length !== show.length) return false;
    for (var i = 0; i < show.length; i++) {
      if (have[i].getAttribute('data-product-handle') !== show[i].h) return false;
    }
    return true;
  };

  Catalog.prototype.render = function (keepFilters, firstPaint) {
    var st = this.state;
    var list = this.sorted(this.filtered(null));
    var total = list.length;

    if (!st.shown || st.shown < this.cfg.first_page) st.shown = this.cfg.first_page;
    if (st.shown > total) st.shown = Math.max(this.cfg.first_page, total);

    var show = list.slice(0, st.shown);
    /* THE FIRST RENDER KEEPS THE RINGS LIQUID ALREADY DREW when they are the
       same rings in the same order. Lorenzo, 23 October: "There is a dealy in
       loading he filter when the page loas. How can we make it load faster
       along with the rest of the page". Rebuilding the grid on load threw away
       the star ratings Fera had already filled in and made Fera fill them
       again, so the stars blinked out and back and the rings jumped twice -
       MEASURED at 1440 on His: Fera's line is 35px per card, the grid 2,411px
       with the stars and 2,222px without. A filter, a sort, Show more or a
       shared link with spf_ in it changes what the grid holds, and those still
       rebuild it. The check compares handles, so it cannot keep a wrong grid.
       SINCE 1 November 2026 THE STARS CANNOT BLINK: they are drawn with the card
       (see Catalog.prototype.card) and no app fills them in afterwards. Keeping
       the rings Liquid drew still saves their pictures being thrown away and
       fetched again, which is why the check is still here. */
    if (!(firstPaint && this.sameAsServer(show))) {
      this.el.grid.innerHTML = show.map(this.card, this).join('');
      /* THE STARS NEED NO SECOND PASS ANY MORE. Until 1 November 2026 this called
         refreshStars(), which asked Fera to fill the two empty boxes every redraw
         left behind. The stars are part of the card now - Catalog.prototype.card
         draws them from the feed - so they are there the moment it is. */
    }

    var word = total === 1 ? this.cfg.word_one : this.cfg.word_many;
    this.el.count.textContent = total + ' ' + word;

    this.el.empty.hidden = total !== 0;
    this.el.more.hidden = total <= st.shown;
    if (!this.el.more.hidden) {
      var left = total - st.shown;
      this.el.more.textContent = 'Show ' + Math.min(left, this.cfg.batch) + ' more';
    }

    if (!keepFilters) this.drawFilters(this.facets());
    this.drawChips();

    var n = this.countFilters();
    if (this.el.fcount) this.el.fcount.textContent = n ? ' (' + n + ')' : '';
    if (this.el.panelBtn) this.el.panelBtn.textContent = 'Show ' + total + ' ' + word;

    /* CLEAR ALL in two more places. In the panel's foot it is always there,
       beside Show N rings, and goes faded and dead when there is nothing to
       clear - disabled, so it does not just look dead, it IS dead. On the
       computer it is a link beside the sidebar's Filter head and is only drawn
       while something is chosen. The page's own chips row keeps its own. */
    var any = this.anyFilter();
    if (this.el.footClear) this.el.footClear.disabled = !any;
    if (this.el.sideClear) this.el.sideClear.hidden = !any;

    this.root.classList.toggle('sp-catalog--filtered', any);
    this.root.classList.remove('is-prefiltered');
    this.el.loading.hidden = true;
  };

  Catalog.prototype.change = function () {
    this.state.shown = this.cfg.first_page;
    this.writeUrl();
    this.render();
  };

  /* FERA USED TO FILL THE STAR RATINGS A SECOND TIME, and refreshStars() was the
     call that asked it to. It is gone, 1 November 2026 (issue #68): the stars are
     part of the card now - Catalog.prototype.card above draws them from the feed -
     so a redraw cannot leave them behind and there is nothing to ask for. What it
     measured while Fera drew them is written down in docs/shopify/reviews-fera-off.
     Nothing else called it. */


  /* ------------------------------- the wiring ------------------------------ */

  Catalog.prototype.bindStatic = function () {
    var self = this;
    /* The groups the shopper has shut by hand, by group key. In memory on
       purpose: it survives every redraw and the panel being shut and opened
       again, and it is gone on the next page load, so every group is open again
       when they come back. */
    this.openGroups = {};
    /* A pair of handles on the move, and the wait before the rings catch up -
       ONE OF EACH PER SLIDER, by key. Two sliders sharing them would let a
       price drag land on the width handles, and the last slider touched would
       cancel the other's wait. */
    this._pending = {};
    this._timers = {};

    // One listener for the whole section: every value, chip, toggle and button.
    this.root.addEventListener('click', function (ev) {
      var t = ev.target;

      var toggle = t.closest && t.closest('[data-sp-toggle]');
      if (toggle) {
        // Read what is on the screen rather than what openGroups holds: a group
        // the shopper has not touched yet has no entry in openGroups at all, so
        // guessing from it would leave the first tap doing nothing.
        var k = toggle.getAttribute('data-sp-toggle');
        self.openGroups[k] = toggle.getAttribute('aria-expanded') !== 'true';
        self.render();
        return;
      }

      // The rail, but not a handle sitting on it - a handle's own click has
      // already moved it and the target there is the input, not the rail.
      var rail = t.closest && t.closest('[data-sp-rail]');
      if (rail && !(t.getAttribute && t.getAttribute('data-sp-range'))) {
        self.sliderTap(rail, ev.clientX);
        return;
      }

      var chip = t.closest && t.closest('[data-sp-chip]');
      if (chip) { self.removeOne(chip.getAttribute('data-sp-chip'), chip.getAttribute('data-sp-chipval')); return; }

      if (t.closest && t.closest('[data-sp-clear]')) { self.clearAll(); return; }

      if (t.closest && t.closest('[data-sp-more]')) {
        self.state.shown += self.cfg.batch;
        self.writeUrl();
        self.render(true);
        return;
      }

      if (t.closest && t.closest('[data-sp-open-filter]')) { self.openPanel(true); return; }
      /* THE PANEL'S TWO APPLY BUTTONS - the one at the top right and the one in
         the foot - and the scrim behind it: all three only close the panel,
         because the filters were applied as they were ticked. The X at the top
         right is gone: Lorenzo, 22 October, "For mobile show Apply button on top
         ring instead of X", and data-sp-panel-close with it, since nothing else
         carried it. */
      if (t.closest && t.closest('[data-sp-panel-apply]')) { self.openPanel(false); return; }
      if (t === self.el.scrim) { self.openPanel(false); return; }
    });

    // A handle on the move: the two amounts and the gold track only.
    this.root.addEventListener('input', function (ev) {
      var r = ev.target;
      if (!r || !r.getAttribute) return;
      if (r.getAttribute('data-sp-range')) self.sliderInput(r);
    });

    /* THE TWO KEYS A SEARCH BOX ANSWERED - Enter doing nothing and Escape
       emptying the box - are gone with the box itself. Escape now does one thing
       everywhere: it closes the panel, through the handler on document below. */

    this.root.addEventListener('change', function (ev) {
      var cb = ev.target;
      // A handle let go, or an arrow key: now the rings catch up.
      if (cb && cb.getAttribute && cb.getAttribute('data-sp-range')) { self.sliderCommit(cb); return; }
      if (!cb || cb.type !== 'checkbox') return;
      var key = cb.getAttribute('data-sp-val');
      if (key) { self.toggleValue(key, cb.value, cb.checked); return; }
    });

    if (this.el.sortForm) {
      this.el.sortForm.addEventListener('submit', function (ev) { ev.preventDefault(); });
    }
    if (this.el.sort) {
      this.el.sort.addEventListener('change', function () {
        var v = self.el.sort.value;
        if (self.degraded) {                    // no data: let Shopify sort it
          var q = new URLSearchParams(location.search);
          if (v) q.set('sort_by', v); else q.delete('sort_by');
          location.search = q.toString();
          return;
        }
        self.state.sort = v;
        if (v === 'best-selling' && !self.best) {
          self.el.loading.hidden = false;
          self.el.loading.textContent = self.cfg.loading_text;
          self.loadBest().then(function () { self.change(); }, function () {
            // Shopify would not give us the order: say so rather than guess one.
            self.el.loading.textContent = 'Best selling is not available just now.';
            self.state.sort = self.cfg.sort_default || 'manual';
            self.el.sort.value = self.state.sort;
          });
          return;
        }
        self.change();
      });
    }

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && self.root.classList.contains('sp-catalog--panel-open')) self.openPanel(false);
    });

    window.addEventListener('popstate', function () {
      if (!self.items) return;
      self.state = self.readUrl();
      self.index();
      if (self.el.sort) self.el.sort.value = self.state.sort;
      self.render();
    });
  };

  Catalog.prototype.toggleValue = function (key, v, on) {
    var arr = this.state.f[key] || (this.state.f[key] = []);
    var i = arr.indexOf(v);
    if (on && i < 0) arr.push(v);
    if (!on && i >= 0) arr.splice(i, 1);
    this.change();
  };

  Catalog.prototype.removeOne = function (key, v) {
    if (this.state.r[key]) { this.clearRange(key); this.change(); return; }
    this.toggleValue(key, v, false);
  };

  // One slider back to the collection's own two ends.
  Catalog.prototype.clearRange = function (key) {
    if (this._timers[key]) clearTimeout(this._timers[key]);   // a commit still in the air
    this._pending[key] = null;
    var cur = this.state.r[key];
    if (cur) { cur.lo = null; cur.hi = null; }
  };

  Catalog.prototype.clearAll = function () {
    var st = this.state, self = this;
    TICKS.forEach(function (g) { st.f[g.key] = []; });
    SLIDE.forEach(function (g) { self.clearRange(g.key); });
    this.change();
  };

  Catalog.prototype.openPanel = function (open) {
    // Nothing is focused on purpose: Lorenzo's rule is that a screen never
    // takes the keyboard by itself. The panel follows the Filter button in the
    // page, so Tab walks straight into it.
    this.root.classList.toggle('sp-catalog--panel-open', open);
    this.el.panel.hidden = !open;
    this.el.scrim.hidden = !open;
    this.el.openFilter.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('sp-catalog-locked', open);
  };

  /* --------------------------------- start -------------------------------- */

  Catalog.prototype.ready = function () {
    this.index();
    if (this.el.sort) this.el.sort.value = this.state.sort;
    this.root.classList.add('sp-catalog--on');
    var self = this;
    if (this.state.sort === 'best-selling') {
      this.loadBest().then(function () { self.render(false, true); }, function () {
        // No order to be had - a search, or Shopify said no. Back to the page's
        // own default, which IS one of the options, so the Sort box still reads.
        self.state.sort = self.cfg.sort_default || 'manual';
        if (self.el.sort) self.el.sort.value = self.state.sort;
        self.render(false, true);
      });
      return;
    }
    this.render(false, true);
  };

  Catalog.prototype.breakDown = function (err) {
    // The rings Liquid already drew stay exactly where they are. Only the
    // filter is missing, and the sort box starts asking Shopify again.
    this.degraded = true;
    this.root.classList.add('sp-catalog--degraded');
    this.root.classList.remove('is-prefiltered');
    if (this.el.loading) this.el.loading.hidden = true;
    if (window.console && console.warn) console.warn('sp-catalog could not read the collection:', err);
  };

  /* ---------------------------------- go ---------------------------------- */

  $$('[data-sp-catalog]').forEach(function (root) {
    try { new Catalog(root); }
    catch (e) {
      root.classList.remove('is-prefiltered');
      if (window.console && console.warn) console.warn('sp-catalog did not start:', e);
    }
  });
})();